import React from "react";
import Grid from "@material-ui/core/Grid";
import "../../Invs/AFReadyDisigen/invoiceprint.css"

function FooterNotes(props) {
    const { inv, found } = props;
    const styfC = { fontSize: "1rem", textAlign: "center", fontWeight: "bold", fontFamily: "Amiri-Regular", paddingBottom: "0.3rem" };
    return (
        <Grid item container
            style={{ padding: 5, fontWeight: "bold", fontFamily: "Amiri-Regular", marginLeft: "0cm" }}
        >
            <Grid
                item
                container
                xs={12}
                style={{ fontWeight: "bold", }}
            >
                <Grid item xs={12} container  >

                    <Grid
                        item
                        xs={12}
                        className={"invoice-footerar"}
                        // style={{
                        //     whiteSpace: 'pre-wrap',
                        //     overflowWrap: 'break-word',
                        //     fontWeight: "bold",
                        //     direction: "rtl",
                        //     fontFamily: "Amiri-Regular",
                        //     textAlign: "right"
                        // }}
                    >
                        {inv.notes}
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        className={"invoice-footerar"}
                        // style={{
                        //     whiteSpace: 'pre-wrap',
                        //     overflowWrap: 'break-word',
                        //     fontWeight: "bold",
                        //     direction: "rtl",
                        //     fontFamily: "Amiri-Regular",
                        //     textAlign: "right"
                        // }}
                    >
                        {found.BillNotes}

                    </Grid>

                    <Grid container item xs={4} style={{ textAlign: "reft", fontFamily: "Amiri-Regular", direction: "ltr" }}  >
                        <br />
                        <br />
                        <Grid item xs={12} >
                            <div style={styfC} > {"توقيع المستلم"}</div>
                        </Grid>
                        <br />
                        <Grid item xs={12} >
                            <div style={styfC}>  {"----------------"}</div>
                        </Grid>
                    </Grid>
                    <Grid item xs={4} ></Grid>

                    <Grid container item xs={4} style={{ textAlign: "reft", fontFamily: "Amiri-Regular", direction: "ltr" }}  >
                        <br />
                        <br />
                        <Grid item xs={12} >
                            <div style={styfC}>  {"توقيع البائع"}</div>
                        </Grid>
                        <br />
                        <Grid item xs={12} >
                            <div style={styfC}> {"----------------"}</div>
                        </Grid>
                    </Grid>


                </Grid>

            </Grid>

        </Grid>

    );
}
export default FooterNotes;

